import { NewMessageFormData } from '@src/main/modules/messages/ui/mailbox/components/new-message/types/NewMessageFormData';
import { SCOption } from '@src/main/modules/messages/ui/mailbox/model/crew-option.model';
import { AutoComplete } from 'primereact/autocomplete';
import React, { FC, SetStateAction, useEffect, useState } from 'react';
import { Control, Controller } from 'react-hook-form';

interface ScListFieldProps {
  control: Control<NewMessageFormData>;
  t: (key: string) => string;
  styles: Record<string, string>;
  scOptions: SCOption[];
  setScQuery: (value: SetStateAction<string>) => void;
}

const renderSCOptionItem = (item: SCOption) => (
  <div>
    {item.name} {item.surname} ({item.payrollNumber})
  </div>
);

const ScListField: FC<ScListFieldProps> = ({ control, t, styles, scOptions, setScQuery }) => {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (inputValue.length >= 3) {
        setScQuery(inputValue);
      }
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [inputValue, setScQuery]);

  return (
    <div className={styles['form-section']}>
      <label>{t('messages.mailbox.recipientTypes.scList.label')}</label>
      <Controller
        name="scs"
        control={control}
        rules={{ required: t('common.validation.fieldRequired') }}
        render={({ field, fieldState }) => (
          <>
            <AutoComplete
              multiple
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              value={field.value as any}
              suggestions={scOptions}
              minLength={1}
              completeMethod={(e) => {
                setInputValue(e.query);
                setScQuery(e.query);
              }}
              onPaste={(e: React.ClipboardEvent) => {
                const pastedText = e.clipboardData?.getData('text') ?? '';
                setInputValue(pastedText);
                setScQuery(pastedText);
              }}
              onChange={(e) => field.onChange(e.value)}
              onInput={(e) => {
                const { value } = (e as React.ChangeEvent<HTMLInputElement>).target;
                setInputValue(value);
                if (value.length >= 3 || value.length === 0) {
                  setScQuery(value);
                }
              }}
              field="label"
              placeholder={t('messages.mailbox.recipientTypes.scList.description')}
              className={fieldState.invalid ? 'p-invalid' : ''}
              itemTemplate={renderSCOptionItem}
              selectedItemTemplate={renderSCOptionItem}
              forceSelection={false}
            />
            {fieldState.error && <small className="p-error">{fieldState.error.message}</small>}
          </>
        )}
      />
    </div>
  );
};
export default ScListField;
